/**
 * Staleness of the Morningstar-derived FI profile (backend strategy/fi_rate_risk.py fi_profile_staleness,
 * CIO 2026-09-30). Labels the estimated sleeve carry and the durations; changes no number. Display only.
 */
export type FiProfileStaleness = {
  refreshed_on?: string | null;
  refresh_age_days?: number | null;
  anchor_date?: string | null;
  anchor_age_days?: number | null;
  stale?: boolean;
  stale_reason?: string | null;
};

/** Tooltip text naming both dates, and why it is stale when it is. */
export const stalenessTitle = (s?: FiProfileStaleness | null): string => {
  if (!s) return "Morningstar profile age unknown.";
  const parts = [
    `Morningstar refresh: ${s.refreshed_on ?? "unknown"}${s.refresh_age_days != null ? ` (${s.refresh_age_days}d ago)` : ""}`,
    `reported yields as of ${s.anchor_date ?? "unknown"}`,
  ];
  return s.stale ? `STALE — ${s.stale_reason ?? "age unknown"}. ${parts.join("; ")}.` : `${parts.join("; ")}.`;
};
